<template>
    <div class="title">
        <canvas id="title-canvas">
        </canvas>
        <h2>案例详情</h2>
    </div>
</template>

<script>
export default {
    name: 'Title',
    mounted () {
        var canvas = document.getElementById('title-canvas')
        var ctx = canvas.getContext('2d')
        canvas.width = document.getElementsByClassName('title')[0].clientWidth
        canvas.height = canvas.width * 0.2
        ctx.font = '800 140px "微软雅黑"'
		ctx.textBaseline = "middle"
        ctx.textAlign = "center"
        ctx.fillStyle = "#f0f0f0"
        ctx.fillText("DETAILS",canvas.width * 0.5 , canvas.height * 0.52)
    }
}
</script>

<style lang="stylus" scoped>
    .title 
        position: relative
        font-size: 42px
        max-width: 1920px
        min-width: 1440px 
        width: 100%
        margin: 0 auto
        #title-canvas
            vertical-align: middle
        h2
            position: absolute
            top: 50%
            left: 50%
            margin: -0.6em 0 0 -2em
            font-weight: 600
            letter-spacing: 2px
            color: #333
            &:after
                content: ''
                position: absolute
                margin-left: -36px
                display: block
                border-bottom: 1px solid #333
                width: 72px
                margin-top: 32px
                left: 50%
</style>


// WEBPACK FOOTER //
// src/components/pc/CaseTitle.vue